import './PdfViewerModal.scss'
import { useEffect, useState } from 'react';
import { formatEpochToDateTime } from '../../../../../utils/commonFunctions';
import { CircularProgress } from '@mui/material';
import { LogoSvg } from '../../../Svgs';
import dayjs from 'dayjs';
import { DownloadCoverageReport } from '../../../types';

const PdfViewerModal = () => {

    const [downloadReporeData, setDownloadReportData] = useState<DownloadCoverageReport | null>(null)
    const close = () => {
        sessionStorage.removeItem('downloadReportData')
        setDownloadReportData(null)
        window.close();
    }

    useEffect(() => {
        const data = sessionStorage.getItem('downloadReportData')
        if (data) {
            setDownloadReportData(JSON.parse(data))
        }
    }, [])

    const handleDownload = async () => {
        document.title = "Target-Revisit-Report";
        window.print()
    };


    return (
        <div className={`pdf__viewer__modal__container`}>
            <div>
                <div id='no-print' className='modal__button__container'>
                    <button className='pdf__modal__close__button' onClick={close}>
                        <i className='fe fe-x' />
                    </button>
                    <button className='download__pdf__button' onClick={handleDownload}>
                        <i className='fe fe-download' />
                    </button>
                </div>
            </div>
            <div className='preview__scroll__container'>
                <div className='pdf__viewer__content' id="pdf-content">
                    <div className='pdf__viewer__header'>
                        <div className='left__header__section'>
                            <span className='header__title'>
                                Target Visibility Analysis
                            </span>
                            <span className='header__time'>
                                {formatEpochToDateTime(dayjs.utc().valueOf() / 1000, 'UTC', 'at')}
                            </span>
                        </div>
                        <div className='logo__container'>
                            <LogoSvg />
                        </div>
                    </div>
                    <div className='pdf__section__1 section_bottom_border'>
                        <div className='section__details__container'>
                            <span className='section__details__left'>Constellation:</span>
                            <span className='section__details__right details__title'>{downloadReporeData?.satellite}</span>
                        </div>
                        <div className='section__details__container'>
                            <span className='section__details__left'>GeoFeature:</span>
                            <span className='section__details__right details__title'>{downloadReporeData?.geoFeatureName}</span>
                        </div>
                        {downloadReporeData?.geoFeatureType === 'Target Track' && <div className='section__details__container'>
                            <span className='section__details__left'>Coordinates:</span>
                            <span className='section__details__right'>{downloadReporeData?.geoFeatureCoordinate}</span>
                        </div>}
                        <div className='section__details__container'>
                            <span className='section__details__left'>Period:</span>
                            <span className='section__details__right'>{downloadReporeData?.geofeaturePeriod}</span>
                        </div>
                    </div>

                    <div className='pdf__section__1'>
                        <div className='section__details__container'>
                            <span className='section__details__left'>Total Revisits:</span>
                            <span className='section__details__right details__title'>{downloadReporeData?.totalRevisites}</span>
                        </div>
                        <div className='section__details__container'>
                            <span className='section__details__left'>Visibility Period:</span>
                            <span className='section__details__right'>{downloadReporeData?.visibilityDuration}</span>
                        </div>
                        <div className='section__details__container'>
                            <span className='section__details__left'>Blind Period:</span>
                            <span className='section__details__right'>{downloadReporeData?.blindDuration}</span>
                        </div>
                    </div>
                    <div className='pdf__viewer__body'>
                        <div className='pdf__viewer__body__left'>
                            <div className='pdf__section__2'>
                                <div className='section__2__table__container'>
                                    <div className='table__header__container'>
                                        <div className='header__section__1'>
                                            <span className='header__section__title'>Pass</span>
                                        </div>
                                        <div className='header__section__2'>
                                            <span className='header__section__title'>Start Time (UTC)<br /> (DD.MM.YYYY / hh:mm:ss:SSS)</span>
                                        </div>
                                        <div className='header__section__3'>
                                            <span className='header__section__title'>End Time (UTC)<br />(DD.MM.YYYY / hh:mm:ss:SSS)</span>
                                        </div>
                                        <div className='header__section__4'>
                                            <span className='header__section__title'>Duration (min)</span>
                                        </div>
                                        <div className='header__section__5'>
                                            <span className='header__section__title'>Visibility </span>
                                        </div>
                                    </div>
                                    {downloadReporeData?.mergedInterval?.map((item, index) => (
                                        <div className={`table__row__container ${item?.isVisible ? '' : 'blind__period'}`} key={index}>
                                            <div className='table__row__section__1'>
                                                <span className='row__section__details'>{item?.isVisible ? item?.satellites ? item?.satellites?.join(', ') : downloadReporeData?.satellite : ''}</span>
                                            </div>
                                            <div className='table__row__section__2'>
                                                <span className='row__section__details'>{item?.start_time}</span>
                                            </div>
                                            <div className='table__row__section__3'>
                                                <span className='row__section__details'>{item?.end_time}</span>
                                            </div>
                                            <div className='table__row__section__4'>
                                                <span className='row__section__details'>{item?.duration}</span>
                                            </div>
                                            <div className='table__row__section__5'>
                                                <span className='row__section__details'>{item?.isVisible ? 'Yes' : 'No'}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PdfViewerModal